export const SELECTORS = {
  UPSELL_VARIANT_DATA: 'js-cart-popup-upsell-variant-data'
};
